
import { Component, OnInit, ViewChild} from '@angular/core';
import { HelperService, AppSettings, AuthenticationService } from '../../../services/_services';
import { Router, Route, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { Base64Pipe } from '../../../services/pipes/base64/base64.pipe';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.css']
})
export class OrderDetailsComponent implements OnInit {

  public regionArr              : any = [
                                          { id: 1, name: 'IT' },
                                          { id: 2, name: 'SEO' },
                                          { id: 3, name: 'SM' },
                                          { id: 4, name: 'HR' },
                                      ];
  public regionNo               : any;
  public activeUser             : any;
  public routerSubscription     : any;
  public orderId                : any;
  public orderDetail            : any;
  public userDetail             : any;

  public DOC_URL                : any = AppSettings.DOC_URL;
  public orders_docs_path       : any = AppSettings.orders_docs_path;

  public noOfPages              : any = AppSettings.noOfPages;
  public orderStatus            : any = AppSettings.orderStatus;
  public subjectArr             : any = ["Biology and Life Sciences","Business and Management","Chemistry","Culture","Economics","Education","English","Environmental Science","Finance, Accounting and Banking","Geography","Project Management","Operational Plan","Critical review","Critical Appraisal","Capstone","Reflective Thinking","Healthcare and Nursing","History and Anthropology","HRM","International Relations","IT","Law and International Law","Linguistics","Literature",
                                          "Marketing and PR","Maths","Philosophy","Physics","Political Science","Psychology","Sociology","Statistics","Other"]
  public citationArr            : any = ["AMA","APA","AMS","Chicago","MLA","Turbian","Other"]
  public orderForm              : FormGroup;

  public orderDate              : any;

  public base64Pipe         : any = new Base64Pipe;

  public websites               : any = [{url:"www.myperfectwords.com", abbr:'MPW'},{url:"www.sharkpapers.com", abbr:'SP'},{url:"www.freeessaywriter.net", abbr:'FEW'},{url:"www.myperfectpaper.net", abbr:'MPP'},
                                        {url:"www.championpapers.com", abbr:'CP'},{url:"www.5staressays.com", abbr:'5SE'},{url:"www.essaywritingservice.college", abbr:'EWS'},{url:"www.writemyessay.help", abbr:'WME'},
                                        {url:"www.essaywriter.college", abbr:'EWC'},{url:"www.collegeessay.org", abbr:'CE'},{url:"www.essaywritingforme.com", abbr:'EWFM'}];
  constructor(
    private authenticationService : AuthenticationService,
    private helperService           : HelperService,
    private activatedRoute          : ActivatedRoute,
    private formBuilder             : FormBuilder,
  ) {
    this.activeUser = this.authenticationService.get_currentUserValue();
    this.routerSubscription = this.activatedRoute.params.subscribe(routeParams => {
      this.orderId = this.base64Pipe.decode(routeParams.slug);
      if (this.orderId.split("-").length > 1) {
        this.orderId = this.orderId.split("-")[1];
      }
      this.getOrderDetails();
  	});

    // Set FormGroup
    this.orderForm = this.formBuilder.group({
      website: [null, Validators.required],
      deadline: [null, Validators.required],
      pages: [null, Validators.required],
      amount: [null, Validators.required],
      name : [null, Validators.required],
      email : [null,[ Validators.required, Validators.email]],
      phone : [null, Validators.required],
      subject : [null, Validators.required],
      citation : [null, Validators.required],
      sources : [null, Validators.required],
      title : [null, Validators.required],
      description : [null, Validators.required]
    });

  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if (typeof this.routerSubscription != 'undefined') {
      //prevent memory leak when component destroyed
      this.routerSubscription.unsubscribe();
    }
  }

  getOrderDetails() {
    let url = AppSettings.API_ENDPOINT + "admin/order";
    let data = { oid : this.orderId};
    this.helperService.httpPostRequestsDecryp(url, data).then(resp => {
      if(typeof resp != "undefined") {
        this.orderDetail = JSON.parse(resp).order;
        console.log(this.orderDetail);
        this.userDetail = JSON.parse(resp).user;
        console.log(this.orderDetail);


        this.orderDate = new Date(this.orderDetail.delivery_date);

      }
    });
  }

}
